import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Tag, ArrowRight } from "lucide-react";
import { CATEGORY_MAP } from "@/data/catalog";

export default function DealsPage() {
  const [deals, setDeals] = useState([]);
  useEffect(() => { api.get("/deals").then((r) => setDeals(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="text-xs font-bold uppercase tracking-widest text-emerald-800">Active offers</div>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-1" style={{ fontFamily: "Outfit" }}>Deals in Islamabad</h1>
      <p className="text-slate-600 mt-1">Handpicked discounts from verified local businesses.</p>

      {deals.length === 0 ? (
        <div className="mt-8 rounded-2xl border-2 border-dashed border-emerald-200 bg-emerald-50/40 p-12 text-center">
          <Tag className="w-10 h-10 text-emerald-700 mx-auto" />
          <div className="mt-3 text-lg font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>No active deals right now.</div>
          <p className="text-slate-600 mt-1 text-sm">Check back soon — new offers are added every week.</p>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {deals.map((d) => {
            const cat = CATEGORY_MAP[d.business?.category];
            const img = d.business?.photos?.[0] || cat?.image;
            return (
              <Link key={d.deal_id} to={`/business/${d.business_id}`} className="group rounded-2xl overflow-hidden border border-slate-200 bg-white card-hover">
                <div className="aspect-[16/9] bg-slate-100 relative">
                  <img src={img} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-3 left-3 bg-amber-500 text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow">
                    {d.discount || "Deal"}
                  </div>
                </div>
                <div className="p-4">
                  <div className="text-xs text-emerald-800 font-semibold uppercase tracking-wider">{d.business?.name} · {d.business?.sector}</div>
                  <div className="font-bold text-slate-900 mt-1" style={{ fontFamily: "Outfit" }}>{d.title}</div>
                  {d.description && <div className="text-sm text-slate-600 mt-1 line-clamp-2">{d.description}</div>}
                  <div className="mt-3 text-sm font-semibold text-emerald-800 flex items-center gap-1 group-hover:gap-2 transition-all">Claim <ArrowRight className="w-4 h-4" /></div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
